import { useState, useEffect } from "react"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleRight, faCircleNotch, faXmark } from '@fortawesome/free-solid-svg-icons'
import Modal from 'react-modal';
import { toast } from 'react-hot-toast';
import Select from "react-select";
import Switch from "react-switch";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import MiniTradeForm from "../components/MiniTradeForm";
import UserSettings from "../components/UserSettings";

function Actions({selectedUser}) {
    const [loading, setLoading] = useState(false);
    const [loading1, setLoading1] = useState(false);
    const [crypto, setCrypto] = useState([]);
    const [fiat, setFiat] = useState([]);
    const [stock, setStock] = useState([]);
    const [wallet, setWallet] = useState([]);
    const [assethistory, setAssethistory] = useState([]);
    useEffect(() => {
        fetch(`${process.env.REACT_APP_API_URL}controller/fetch.controller.php`, {
            credentials: "include",
            method: "POST",
            headers: {
            "Content-Type": "application/json"
            },
            body: JSON.stringify({ fetchwallet1: true, user : selectedUser.email  })
        })
        .then(response => response.json())
        .then(data => {
            if (data.status === "success") {
            setWallet(data.wallet);
            }
        })
        .catch(err => {
            
        })
    }, [selectedUser]);
    useEffect(() => {
        fetch(`/coin_list.txt`)
        .then((res) => res.json())
        .then((data) => {
        var coinList = data.data;
        const updatedData = coinList.map((coin, index) => ({
            id: index + 1,
            logo: `https://s2.coinmarketcap.com/static/img/coins/64x64/${coin.id}.png`,
            name: coin.name,
            type: 'crypto',
            symbol: coin.symbol,
            price: Number(coin.quote.USD.price.toFixed(2)),
            label: <><img src={`https://s2.coinmarketcap.com/static/img/coins/64x64/${coin.id}.png`} alt={coin.symbol} width="20" /> {coin.symbol}</>,
            value: coin.name,
            amount: 0,
        }));
        setCrypto(updatedData);
        })
        .catch((err) => console.error("Error loading coin list:", err));
    }, []);
    useEffect(() => {
        fetch(`/stock_list.txt`)
        .then((res) => res.json())
        .then((data) => {
        const stockList = Object.values(data);
        const updatedData = stockList.map((stock, index) => ({
            id: index + 1,
            logo: `https://images.financialmodelingprep.com/symbol/${stock.symbol}.png`,
            name: stock.name,
            type: 'stock',
            symbol: stock.symbol,
            price: Number(stock.price.toFixed(2)),
            label: <><img src={`https://images.financialmodelingprep.com/symbol/${stock.symbol}.png`} alt={stock.symbol} width="20" /> {stock.symbol}</>,
            value: stock.name,
            amount: 0,
        }));
        setStock(updatedData);
        })
        .catch((err) => console.error("Error loading coin list:", err));
    }, []);
    useEffect(() => {   
        fetch(`/fiat_list.txt`)
        .then((res) => res.json())
        .then((data) => {
        const wantedCurrencies = {
            AUD: 'Australian Dollar',
            CAD: 'Canadian Dollar',
            CHF: 'Swiss Franc',
            CNY: 'Chinese Yuan',
            EUR: 'Euro',
            GBP: 'British Pound',
            INR: 'Indian Rupee',
            JPY: 'Japanese Yen',
            RUB: 'Russian Ruble',
            USD: 'US Dollar',
            ZAR: 'South African Rand'
        };
        const fiatList = Object.entries(data)
            .filter(([code]) => wantedCurrencies.hasOwnProperty(code))
            .map(([code, value], index) => ({
            id: index + 1,
            symbol: code,
            name: wantedCurrencies[code],
            price: Number(value),
            type: 'fiat',
            label: <><img src={`https://flagcdn.com/w40/${code.slice(0, 2).toLowerCase()}.png`} alt={code} width="20" /> {code}</>,
            value: wantedCurrencies[code],
            logo: `https://flagcdn.com/w40/${code.slice(0, 2).toLowerCase()}.png`,
            amount: 0,
            }));
        
        setFiat(fiatList);
        })
        .catch((err) => console.error("Error loading coin list:", err));
    }, []);
    useEffect(() => {
        if (!crypto.length && !fiat.length && !stock.length) return;
        const walletMap = wallet.reduce((acc, item) => {
        const key = item.coinName?.trim().toLowerCase();
        acc[key] = parseFloat(item.balance) || 0;
        return acc;
        }, {});
        let total = 0;
        const applyWalletBalance = (list) =>
        list.map(item => {
            const key = item.name?.trim().toLowerCase();
            const matchedBalance = walletMap[key];
            const amount = matchedBalance || 0;
            const value = amount * item.price;
            total += value;
            return {
            ...item,
            amount: matchedBalance || 0
            };
        });
        const merged = [
        ...applyWalletBalance(crypto),
        ...applyWalletBalance(fiat),
        ...applyWalletBalance(stock)
        ];
        const sorted = merged.sort((a, b) => {
        if (b.amount > 0 && a.amount === 0) return 1;
        if (a.amount > 0 && b.amount === 0) return -1;
        return a.name.localeCompare(b.name);
        });
        setAssethistory(sorted);
    }, [crypto, fiat, stock, wallet]);

    //ALL Modals
    const [modalIsOpen, setIsOpen] = useState(false);
    const [modalIsOpen1, setIsOpen1] = useState(false);
    const [modalIsOpen2, setIsOpen2] = useState(false);
    const [modalIsOpen3, setIsOpen3] = useState(false);
    const [modalIsOpen4, setIsOpen4] = useState(false);
    const [modalIsOpen5, setIsOpen5] = useState(false);
    const [modalIsOpen6, setIsOpen6] = useState(false);
    const [modalIsOpen7, setIsOpen7] = useState(false);
    const [modalIsOpen8, setIsOpen8] = useState(false);
    const [modalIsOpen9, setIsOpen9] = useState(false);
    const [modalIsOpen10, setIsOpen10] = useState(false);
    const [modalIsOpen11, setIsOpen11] = useState(false);
    const [modalIsOpen12, setIsOpen12] = useState(false);
    const [modalIsOpen13, setIsOpen13] = useState(false);
    const [modalIsOpen14, setIsOpen14] = useState(false);
    const [modalIsOpen15, setIsOpen15] = useState(false);
    const [modalIsOpen16, setIsOpen16] = useState(false);
    const [modalIsOpen17, setIsOpen17] = useState(false);
    //ALL REQUEST
    const [ntitle, setNtitle] = useState()
    const [nmessage, setNmessage] = useState()
    const SendNotification = () =>{
        setLoading(true);
        fetch(`${process.env.REACT_APP_API_URL}controller/manage.controller.php`, {
        credentials: "include",
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({ sendnot: true, email: selectedUser.email, title: ntitle, message: nmessage})
        })
        .then(response => response.json())
        .then(data => {
        if (data.status === "success") {
            toast.success(data.result);
            setIsOpen(false);
        }else{
            toast.error(data.message);
        }
        setLoading(false);
        })
        .catch(err => {
            setLoading(false);
        })
    }
    const [ptitle, setPtitle] = useState(selectedUser.upgrade_title)
    const [pmessage, setPmessage] = useState(selectedUser.upgrade_text)
    const SendPop = () =>{
        setLoading(true);
        fetch(`${process.env.REACT_APP_API_URL}controller/manage.controller.php`, {
        credentials: "include",
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({ sendpop: true, email: selectedUser.email, title: ptitle, message: pmessage})
        })
        .then(response => response.json())
        .then(data => {
        if (data.status === "success") {
            toast.success(data.result);
            setIsOpen1(false);
        }else{
            toast.error(data.message);
        }
        setLoading(false);
        })
        .catch(err => {
            setLoading(false);
        })
    }
    const DeletePop = () =>{
        setLoading1(true);
        fetch(`${process.env.REACT_APP_API_URL}controller/manage.controller.php`, {
        credentials: "include",
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({ deletepop: true, email: selectedUser.email})
        })
        .then(response => response.json())
        .then(data => {
        if (data.status === "success") {
            toast.success(data.result);
            setIsOpen1(false);
        }else{
            toast.error(data.message);
        }
        setLoading1(false);
        })
        .catch(err => {
            setLoading1(false);
        })
    }
    const darkThemeStyles1 = {
      control: (styles) => ({
        ...styles,
        backgroundColor: "rgb(30, 33, 36)",
        border: "none",
        color: "#fff",
        fontWeight: '600',
      }),
      menu: (styles) => ({
        ...styles,
        backgroundColor: "rgb(30, 33, 36)",
        fontWeight: '600',
      }),
      option: (styles, { isFocused, isSelected }) => ({
        ...styles,
        backgroundColor: isSelected ? "#151719" : isFocused ? "#151719" : "rgb(30, 33, 36)",
        color: "#fff",
        fontWeight: '600',
      }),
      singleValue: (styles) => ({
        ...styles,
        color: "#fff",
        fontWeight: '600',
      }),
    };
    const darkThemeStyles = {
        control: (styles) => ({
        ...styles,
        backgroundColor: "#151719",
        border: "none",
        color: "#fff",
        }),
        menu: (styles) => ({
        ...styles,
        backgroundColor: "#151719",
        }),
        option: (styles, { isFocused, isSelected }) => ({
        ...styles,
        backgroundColor: isSelected ? "rgb(30, 33, 36)" : isFocused ? "rgb(30, 33, 36)" : "#151719",
        color: "#fff",
        }),
        singleValue: (styles) => ({
        ...styles,
        color: "#fff",
        }),
    };
    const fundoptions = [
        { value: "regular", label: "Regular deposit" },
        { value: "signal", label: "Signal deposit" },
        { value: "subscription", label: "Subscription deposit" },
    ];
    const [dtype, setDtype] = useState()
    const [damount, setDamount] = useState()
    const [dasset, setDasset] = useState()
    const [dsymbol, setDsymbol] = useState();
    const [dprice, setDprice] = useState();
    const [dbalance, setDbalance] = useState(0);
    const AddBalance = () =>{
        setLoading(true);
        fetch(`${process.env.REACT_APP_API_URL}controller/manage.controller.php`, {
          credentials: "include",
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({ funduser1: true, email: selectedUser?.email, asset:dasset, amount:damount, symbol :dsymbol, type : dtype, price:dprice })
        })
        .then(response => response.json())
        .then(data => {
          if (data.status === "success") {
            toast.success(data.result);
            setIsOpen2(false);
          }else{
            toast.error(data.message);
          }
          setLoading(false);
        })
        .catch(err => {
          console.error(err);
          setLoading(false);
        })
    }

    const [pamount, setPamount] = useState()
    const [passet, setPasset] = useState()
    const [psymbol, setPsymbol] = useState()
    const [pprice, setPprice] = useState();
    const AddProfit = () =>{
        setLoading(true);
        fetch(`${process.env.REACT_APP_API_URL}controller/manage.controller.php`, {
          credentials: "include",
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({ addprofit: true, email: selectedUser?.email, asset:passet, amount:pamount, price:pprice, symbol:psymbol, activity : "" })
        })
        .then(response => response.json())
        .then(data => {
          if (data.status === "success") {
            toast.success(data.result);
            setIsOpen3(false);
          }else{
            toast.error(data.message);
          }
          setLoading(false);
        })
        .catch(err => {
          console.error(err);
          setLoading(false);
        })
    }

    const [lamount, setLamount] = useState()
    const [lasset, setLasset] = useState()
    const [lsymbol, setLsymbol] = useState()
    const [lprice, setLprice] = useState();
    const [lbalance, setLbalance] = useState();
    const AddLoss = () =>{
        setLoading(true);
        fetch(`${process.env.REACT_APP_API_URL}controller/manage.controller.php`, {
          credentials: "include",
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({ addloss: true, email: selectedUser?.email, asset:lasset, amount:lamount, price:lprice, symbol:lsymbol })
        })
        .then(response => response.json())
        .then(data => {
          if (data.status === "success") {
            toast.success(data.result);
            setIsOpen4(false);
          }else{
            toast.error(data.message);
          }
          setLoading(false);
        })
        .catch(err => {
          console.error(err);
          setLoading(false);
        })
    }
    const [checked, setChecked] = useState();
    const [rasset, setRasset] = useState()
    const [rsymbol, setRsymbol] = useState()
    const [rbalance, setRbalance] = useState();
    const ResetAsset = () =>{
        setLoading(true);
        var all
        if(checked){
            all = "true";
        }else{
            all = "false";
        }
        fetch(`${process.env.REACT_APP_API_URL}controller/manage.controller.php`, {
          credentials: "include",
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({ resetasset: true, email: selectedUser?.email, asset:rasset, symbol:rsymbol, all:all })
        })
        .then(response => response.json())
        .then(data => {
          if (data.status === "success") {
            toast.success(data.result);
            setIsOpen5(false);
          }else{
            toast.error(data.message);
          }
          setLoading(false);
        })
        .catch(err => {
          console.error(err);
          setLoading(false);
        })
    }
    const [progress, setProgress] = useState()
    const SetProgress = () =>{
        setLoading(true);
        fetch(`${process.env.REACT_APP_API_URL}controller/manage.controller.php`, {
          credentials: "include",
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({ setprogress: true, email: selectedUser?.email, progress:progress })
        })
        .then(response => response.json())
        .then(data => {
          if (data.status === "success") {
            toast.success(data.result);
            setIsOpen6(false);
          }else{
            toast.error(data.message);
          }
          setLoading(false);
        })
        .catch(err => {
          console.error(err);
          setLoading(false);
        })
    }
    const [signalStrength, setSignalStrength] = useState()
    const SetSignal = () =>{
        setLoading(true);
        fetch(`${process.env.REACT_APP_API_URL}controller/manage.controller.php`, {
          credentials: "include",
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({ setsignal: true, email: selectedUser?.email, signal:signalStrength })
        })
        .then(response => response.json())
        .then(data => {
          if (data.status === "success") {
            toast.success(data.result);
            setIsOpen7(false);
          }else{
            toast.error(data.message);
          }
          setLoading(false);
        })
        .catch(err => {
          console.error(err);
          setLoading(false);
        })
    }

    const deleteAccount = () =>{
        fetch(`${process.env.REACT_APP_API_URL}controller/manage.controller.php`, {
          credentials: "include",
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({ deleteAccount: true, email: selectedUser?.email })
        })
        .then(response => response.json())
        .then(data => {
          if (data.status === "success") {
            toast.success(data.result);
            setTimeout(() => {
                window.location.href = "manage";
            }, 2000);
          }else{
            toast.error(data.message);
          }
        })
        .catch(err => {
          console.error(err);
        })
    }
    const SendMail = () => {
      fetch(`${process.env.REACT_APP_API_URL}controller/manage.controller.php`, {
          credentials: "include",
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({ verifymail: true, email: selectedUser?.email })
      })
        .then(response => response.json())
        .then(data => {
          if (data.status === "success") {
            toast.success(data.result);
            window.location.reload();
          }else{
            toast.error(data.message);
          }
        })
        .catch(err => {
          console.error(err)
      })
    }
    const verifyAccount = () =>{
        fetch(`${process.env.REACT_APP_API_URL}controller/manage.controller.php`, {
          credentials: "include",
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({ verifyAccount: true, email: selectedUser?.email })
        })
        .then(response => response.json())
        .then(data => {
          if (data.status === "success") {
            toast.success(data.result);
            setTimeout(() => {
                window.location.href = "manage";
            }, 2000);
          }else{
            toast.error(data.message);
          }
        })
        .catch(err => {
          console.error(err);
        })
    }
    const LockTrade = () =>{
        fetch(`${process.env.REACT_APP_API_URL}controller/manage.controller.php`, {
          credentials: "include",
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({ locktrade: true, email: selectedUser?.email })
        })
        .then(response => response.json())
        .then(data => {
          if (data.status === "success") {
            toast.success(data.result);
            setTimeout(() => {
                window.location.href = "manage";
            }, 2000);
          }else{
            toast.error(data.message);
          }
        })
        .catch(err => {
          console.error(err);
        })
    }
    const LockCopy = () =>{
        fetch(`${process.env.REACT_APP_API_URL}controller/manage.controller.php`, {
          credentials: "include",
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({ lockcopytrade: true, email: selectedUser?.email })
        })
        .then(response => response.json())
        .then(data => {
          if (data.status === "success") {
            toast.success(data.result);
            setTimeout(() => {
                window.location.href = "manage";
            }, 2000);
          }else{
            toast.error(data.message);
          }
        })
        .catch(err => {
          console.error(err);
        })
    }

    const typeoptions = [
        { value: "add", label: "Add to signal balance" },
        { value: "remove", label: "Remove from signal balance" },
    ];
    const [stype, setStype] = useState()
    const [samount, setSamount] = useState()
    const AddSignalBal = () =>{ 
        setLoading(true);
        fetch(`${process.env.REACT_APP_API_URL}controller/manage.controller.php`, {
          credentials: "include",
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({ addSignalBal: true, email: selectedUser?.email, type:stype, amount:samount })
        })
        .then(response => response.json())
        .then(data => {
          if (data.status === "success") {
            toast.success(data.result);
            setIsOpen8(false);
          }else{
            toast.error(data.message);
          }
          setLoading(false);
        })
        .catch(err => {
          console.error(err);
          setLoading(false);
        })
    }

    const typeoptions1 = [
        { value: "add", label: "Add to subscription balance" },
        { value: "remove", label: "Remove from subscription balance" },
    ];
    const [sbtype, setSbtype] = useState()
    const [sbamount, setSbamount] = useState()
    const AddSubBal = () =>{
        setLoading(true);
        fetch(`${process.env.REACT_APP_API_URL}controller/manage.controller.php`, {
          credentials: "include",
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({ addSubBal: true, email: selectedUser?.email, type:sbtype, amount:sbamount })
        })
        .then(response => response.json())
        .then(data => {
          if (data.status === "success") {
            toast.success(data.result);
            setIsOpen9(false);
          }else{
            toast.error(data.message);
          }
          setLoading(false);
        })
        .catch(err => {
          console.error(err);
          setLoading(false);
        })
    }

    const typeoptions2 = [
        { value: "add", label: "Add to referral balance" },
        { value: "remove", label: "Remove from referral balance" },
    ];
    const [rtype, setRtype] = useState()
    const [ramount, setRamount] = useState()
    const AddRefBal = () =>{
        setLoading(true);
        fetch(`${process.env.REACT_APP_API_URL}controller/manage.controller.php`, {
          credentials: "include",
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({ addRefBal: true, email: selectedUser?.email, type:rtype, amount:ramount })
        })
        .then(response => response.json())
        .then(data => {
          if (data.status === "success") {
            toast.success(data.result);
            setIsOpen10(false);
          }else{
            toast.error(data.message);
          }
          setLoading(false);
        })
        .catch(err => {
          console.error(err);
          setLoading(false);
        })
    }

    const typeoptions3 = [
        { value: "add", label: "Add to profit" },
        { value: "remove", label: "Remove from profit" },
    ];
    const [ptype, setPtype] = useState()
    const [pramount, setPramount] = useState()
    const AddProfitBal = () =>{
        setLoading(true);
        fetch(`${process.env.REACT_APP_API_URL}controller/manage.controller.php`, {
          credentials: "include",
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({ addProfitBal: true, email: selectedUser?.email, type:ptype, amount:pramount })
        })
        .then(response => response.json())
        .then(data => {
          if (data.status === "success") {
            toast.success(data.result);
            setIsOpen11(false);
          }else{
            toast.error(data.message);
          }
          setLoading(false);
        })
        .catch(err => {
          console.error(err);
          setLoading(false);
        })
    }

    const [planlist, setPlanList] = useState([])
    const [plan, setPlan] = useState()
    const [planAmount, setPlanAmount] = useState()
    useEffect(() => {
        fetch(`${process.env.REACT_APP_API_URL}controller/fetch.controller.php`, {
            credentials: "include",
            method: "POST",
            headers: {
            "Content-Type": "application/json"
            },
            body: JSON.stringify({ fetchPlan: true})
        })
        .then(response => response.json())
        .then(data => {
            if (data.status === "success") {
                var plans = data.plans;
                const updatedData = plans.map((plan, index) => ({
                    id: index + 1,
                    label: plan.subscribe_name,
                    value: plan.subscribe_name,
                    amount: plan.amount,
                }));
                setPlanList(updatedData);
            }
        })
        .catch(err => {
        })
    }, [selectedUser]);
    const UpgradeAccount = () =>{
        setLoading(true);
        fetch(`${process.env.REACT_APP_API_URL}controller/manage.controller.php`, {
          credentials: "include",
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({ upgradeaccount: true, email: selectedUser?.email, plan:plan, amount:planAmount })
        })
        .then(response => response.json())
        .then(data => {
          if (data.status === "success") {
            toast.success(data.result);
            setIsOpen12(false);
          }else{
            toast.error(data.message);
          }
          setLoading(false);
        })
        .catch(err => {
          console.error(err);
          setLoading(false);
        })
    }
    const depositlist = [
        { value: 5, label: 5 },
        { value: 10, label: 10 },
        { value: 20, label: 20 },
        { value: 30, label: 30 },
        { value: 40, label: 40 },
        { value: 50, label: 50 },
        { value: 100, label: 100 },
    ];
    const statuslist = [
        { value: "pending", label: "Pending" },
        { value: "success", label: "Success" },
        { value: "failed", label: "Failed" },
    ];
    const withdrawlist = [
        { value: "Bank Transfer", label: "Bank Transfer" },
        { value: "Crypto", label: "Crypto" },
        { value: "Paypal", label: "Paypal" },
        { value: "Skrill", label: "Skrill" },
    ];
    const [fromDate, setFromDate] = useState(new Date());
    const [toDate, setToDate] = useState(new Date());
    const [noGenerate, setNoGenerate] = useState()
    const [tasset, setTasset] = useState()
    const [wtype, setWtype] = useState()
    const [tstatus, setTstatus] = useState()
    const GenerateDeposit = () =>{
        setLoading(true);
        fetch(`${process.env.REACT_APP_API_URL}controller/manage.controller.php`, {
          credentials: "include",
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({ generatedeposit: true, email: selectedUser?.email, fromDate:fromDate, toDate:toDate, noGenerate:noGenerate, tasset:tasset, tstatus:tstatus })
        })
        .then(response => response.json())
        .then(data => {
          if (data.status === "success") {
            toast.success(data.result);
            setIsOpen13(false);
          }else{
            toast.error(data.message);
          }
          setLoading(false);
        })
        .catch(err => {
          console.error(err);
          setLoading(false);
        })
    }
    const GenerateWithdraw = () =>{
        setLoading(true);
        fetch(`${process.env.REACT_APP_API_URL}controller/manage.controller.php`, {
          credentials: "include",
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({ generatewithdraw: true, email: selectedUser?.email, fromDate:fromDate, toDate:toDate, noGenerate:noGenerate, wtype:wtype, tstatus:tstatus, tasset : tasset })
        })
        .then(response => response.json())
        .then(data => {
          if (data.status === "success") {
            toast.success(data.result);
            setIsOpen14(false);
          }else{
            toast.error(data.message);
          }
          setLoading(false);
        })
        .catch(err => {
          console.error(err);
          setLoading(false);
        })
    }

    const [stamount, setStamount] = useState()
    const [stasset, setStasset] = useState()
    const [stsymbol, setStsymbol] = useState()
    const [stprice, setStprice] = useState();
    const Addstock = () =>{
        setLoading(true);
        fetch(`${process.env.REACT_APP_API_URL}controller/manage.controller.php`, {
          credentials: "include",
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({ btn_invest: true, email: selectedUser?.email, name:stasset, amount:stamount, price:stprice, symbol:stsymbol })
        })
        .then(response => response.json())
        .then(data => {
          if (data.status === "success") {
            toast.success(data.result);
            setIsOpen17(false);
            setTimeout(() => {
              window.location.href = "manage";
            }, 2000);
          }else{
            toast.error(data.message);
          }
          setLoading(false);
        })
        .catch(err => {
          console.error(err);
          setLoading(false);
        })
    }
    return (
        <div className="mb-5">
            <p className="fw-bold mb-0">Actions</p>
            <p className="mb-0" style={{fontSize:'14px'}}>Perform actions on user account</p>
            <div className="rounded-2 mt-4 p-2" style={{backgroundColor: '#ffffff06'}}>
                <div className="hoverGlow" onClick={() => setIsOpen16(true)}>
                    <p className="mb-0">User Settings</p>
                    <FontAwesomeIcon icon={faAngleRight} style={{fontSize: '12px'}} />
                </div>
                <div className="hoverGlow" onClick={() => setIsOpen(true)}>
                    <p className="mb-0">Send notification</p>
                    <FontAwesomeIcon icon={faAngleRight} style={{fontSize: '12px'}} />
                </div>
                <div className="hoverGlow" onClick={() => setIsOpen1(true)}>
                    <p className="mb-0">Send pop-up message</p>
                    <FontAwesomeIcon icon={faAngleRight} style={{fontSize: '12px'}} />
                </div>
                <div className="hoverGlow" onClick={() => setIsOpen2(true)}>
                    <p className="mb-0">Add deposit</p>
                    <FontAwesomeIcon icon={faAngleRight} style={{fontSize: '12px'}} />
                </div>
                <div className="hoverGlow" onClick={() => setIsOpen17(true)}>
                    <p className="mb-0">Add stake</p>
                    <FontAwesomeIcon icon={faAngleRight} style={{fontSize: '12px'}} />
                </div>
                <div className="hoverGlow" onClick={() => setIsOpen3(true)}>
                    <p className="mb-0">Add profits</p>
                    <FontAwesomeIcon icon={faAngleRight} style={{fontSize: '12px'}} />
                </div>
                <div className="hoverGlow" onClick={() => setIsOpen4(true)}>
                    <p className="mb-0">Add loss</p>
                    <FontAwesomeIcon icon={faAngleRight} style={{fontSize: '12px'}} />
                </div>
                <div className="hoverGlow" onClick={() => setIsOpen5(true)}>
                    <p className="mb-0">Reset User Balance</p>
                    <FontAwesomeIcon icon={faAngleRight} style={{fontSize: '12px'}} />
                </div>
                <div className="hoverGlow" onClick={() => setIsOpen6(true)}>
                    <p className="mb-0">Set trading progress</p>
                    <FontAwesomeIcon icon={faAngleRight} style={{fontSize: '12px'}} />
                </div>
                <div className="hoverGlow" onClick={() => setIsOpen7(true)}>
                    <p className="mb-0">Set signal strength</p>
                    <FontAwesomeIcon icon={faAngleRight} style={{fontSize: '12px'}} />
                </div>
                <div className="hoverGlow" onClick={() => setIsOpen15(true)}>
                    <p className="mb-0">Fix a trade</p>
                    <FontAwesomeIcon icon={faAngleRight} style={{fontSize: '12px'}} />
                </div>
                <div className="hoverGlow" onClick={() => setIsOpen8(true)}>
                    <p className="mb-0">Manage signal balance</p>
                    <FontAwesomeIcon icon={faAngleRight} style={{fontSize: '12px'}} />
                </div>
                <div className="hoverGlow" onClick={() => setIsOpen9(true)}>
                    <p className="mb-0">Manage subscription balance</p>
                    <FontAwesomeIcon icon={faAngleRight} style={{fontSize: '12px'}} />
                </div>
                <div className="hoverGlow" onClick={() => setIsOpen10(true)}>
                    <p className="mb-0">Manage referral balance</p>
                    <FontAwesomeIcon icon={faAngleRight} style={{fontSize: '12px'}} />
                </div>
                <div className="hoverGlow" onClick={() => setIsOpen11(true)}>
                    <p className="mb-0">Manage user profits</p>
                    <FontAwesomeIcon icon={faAngleRight} style={{fontSize: '12px'}} />
                </div>
                <div className="hoverGlow" onClick={() => setIsOpen12(true)}>
                    <p className="mb-0">Upgrade Account</p>
                    <FontAwesomeIcon icon={faAngleRight} style={{fontSize: '12px'}} />
                </div>
                <div className="hoverGlow" onClick={() => setIsOpen13(true)}>
                    <p className="mb-0">Generate deposit history</p>
                    <FontAwesomeIcon icon={faAngleRight} style={{fontSize: '12px'}} />
                </div>
                <div className="hoverGlow" onClick={() => setIsOpen14(true)}>
                    <p className="mb-0">Generate withdrawal history</p>
                    <FontAwesomeIcon icon={faAngleRight} style={{fontSize: '12px'}} />
                </div>
                <div className="hoverGlow" onClick={() => SendMail()}>
                    <p className="mb-0">Resend Email Verification</p>
                    <FontAwesomeIcon icon={faAngleRight} style={{fontSize: '12px'}} />
                </div>
                <div className="hoverGlow" onClick={() => verifyAccount()}>
                    <p className="mb-0">{`${(selectedUser.verify == 1)?'Unverify':'Verify'} Account`}</p>
                    <FontAwesomeIcon icon={faAngleRight} style={{fontSize: '12px'}} />
                </div>
                <div className="hoverGlow" onClick={() => LockCopy()}>
                    <p className="mb-0">{`${(selectedUser.lock_copytrade == 1)?'Unlock':'Lock'} Copy Expert`}</p>
                    <FontAwesomeIcon icon={faAngleRight} style={{fontSize: '12px'}} />
                </div>
                <div className="hoverGlow" onClick={() => LockTrade()}>
                    <p className="mb-0">{`${(selectedUser.trading_status == 0)?'Unlock':'Lock'} Trade`}</p>
                    <FontAwesomeIcon icon={faAngleRight} style={{fontSize: '12px'}} />
                </div>
                <div className="hoverGlow" onClick={() => deleteAccount()}>
                    <p className="mb-0">{`${(selectedUser.deleted == 0)?'Block':'Unblock'} user account`}</p>
                    <FontAwesomeIcon icon={faAngleRight} style={{fontSize: '12px'}} />
                </div>
            </div>
            {/* ALL MODALS */}
            {/* ALL MODALS */}
            {/* ALL MODALS */}
            <Modal
                isOpen={modalIsOpen}
                onRequestClose={() => setIsOpen(false)}
                shouldCloseOnOverlayClick={true} 
                closeTimeoutMS={100}
                className="shortmode"
            >
                <div className="d-flex align-items-center justify-content-between">
                    <p className="mb-0 fw-bold text-white" style={{fontSize: '15px'}}>Send notification</p>
                    <FontAwesomeIcon className="py-1 px-2 rounded-3" icon={faXmark} style={{fontSize: '15px', backgroundColor: 'rgba(255, 255, 255, 0.1)', cursor: 'pointer'}} onClick={() => setIsOpen(false)} />
                </div>
                <p className="mb-3 mt-2 text-light fw-semibold" style={{fontSize: '15px'}}>This notification will not auto-translate to user's language. Please take note of the language you send the notification in.</p>
                <label className="fw-semibold mb-2" style={{fontSize: '14px'}}>User:</label>
                <div className="d-flex align-items-between form-control justify-content-between py-1 pe-1">
                    <input 
                        type="text" 
                        placeholder={selectedUser.email}
                        className="inputNone w-100 py-1"
                        value={selectedUser.email}
                        readOnly
                    />
                </div>
                <label className="fw-semibold mb-2" style={{fontSize: '14px'}}>Title:</label>
                <div className="d-flex align-items-between form-control justify-content-between py-1 pe-1">
                    <input 
                        type="text" 
                        placeholder="Deposit"
                        className="inputNone w-100 py-1"
                        value={ntitle}
                        onChange={(e) => setNtitle(e.target.value)}
                    />
                </div>
                <label className="fw-semibold mb-2 mt-3" style={{fontSize: '14px'}}>Message:</label>
                <div className="d-flex align-items-between form-control justify-content-between py-1 pe-1">
                    <textarea 
                    placeholder="Your deposit was successful"
                    className="inputNone w-100 py-1"
                    value={nmessage}
                    onChange={(e) => setNmessage(e.target.value)}
                    rows={5}
                    />
                </div>
                <div className={`myBtn bg-prime w-100 text-center mt-3`} style={{paddingTop: '12px',paddingBottom: '12px'}} onClick={SendNotification}>{loading?<FontAwesomeIcon icon={faCircleNotch} style={{fontSize: '20px', color: 'white', opacity: '0.5'}} spin />:'Send'}</div>
            </Modal>
            <Modal
                isOpen={modalIsOpen1}
                onRequestClose={() => setIsOpen1(false)}
                shouldCloseOnOverlayClick={true} 
                closeTimeoutMS={100}
                className="shortmode"
            >
                <div className="d-flex align-items-center justify-content-between">
                    <p className="mb-0 fw-bold text-white" style={{fontSize: '15px'}}>Send pop-up message</p>
                    <FontAwesomeIcon className="py-1 px-2 rounded-3" icon={faXmark} style={{fontSize: '15px', backgroundColor: 'rgba(255, 255, 255, 0.1)', cursor: 'pointer'}} onClick={() => setIsOpen1(false)} />
                </div>
                <p className="mb-3 mt-2 text-light fw-semibold" style={{fontSize: '15px'}}>This pop-up message will not auto-translate to user's language. Please take note of the language you send the pop-up message in.</p>
                <label className="fw-semibold mb-2" style={{fontSize: '14px'}}>User:</label>
                <div className="d-flex align-items-between form-control justify-content-between py-1 pe-1">
                    <input 
                        type="text" 
                        placeholder={selectedUser.email}
                        className="inputNone w-100 py-1"
                        value={selectedUser.email}
                        readOnly
                    />
                </div>
                <label className="fw-semibold mb-2" style={{fontSize: '14px'}}>Title:</label>
                <div className="d-flex align-items-between form-control justify-content-between py-1 pe-1">
                    <input 
                        type="text" 
                        placeholder="Deposit now"
                        className="inputNone w-100 py-1"
                        value={ptitle}
                        onChange={(e) => setPtitle(e.target.value)}
                    />
                </div>
                <label className="fw-semibold mb-2 mt-3" style={{fontSize: '14px'}}>Message:</label>
                <div className="d-flex align-items-between form-control justify-content-between py-1 pe-1">
                    <textarea 
                    placeholder="Make a deposit"
                    className="inputNone w-100 py-1"
                    value={pmessage}
                    onChange={(e) => setPmessage(e.target.value)}
                    rows={5}
                    />
                </div>
                <div className="d-flex align-items-center justify-content-between mt-4" style={{gap: '12px'}}>
                    <div className={`myBtn bg-danger w-100 text-center mt-3`} style={{paddingTop: '12px',paddingBottom: '12px'}} onClick={DeletePop}>{loading1?<FontAwesomeIcon icon={faCircleNotch} style={{fontSize: '20px', color: 'white', opacity: '0.5'}} spin />:'Delete'}</div>
                    <div className={`myBtn bg-prime w-100 text-center mt-3`} style={{paddingTop: '12px',paddingBottom: '12px'}} onClick={SendPop}>{loading?<FontAwesomeIcon icon={faCircleNotch} style={{fontSize: '20px', color: 'white', opacity: '0.5'}} spin />:'Send'}</div>
                </div>
            </Modal>
            <Modal
                isOpen={modalIsOpen2}
                onRequestClose={() => setIsOpen2(false)}
                shouldCloseOnOverlayClick={true} 
                closeTimeoutMS={100}
                className="shortmode"
            >
                <div className="d-flex align-items-center justify-content-between">
                    <p className="mb-0 fw-bold text-white" style={{fontSize: '15px'}}>Add deposit</p>
                    <FontAwesomeIcon className="py-1 px-2 rounded-3" icon={faXmark} style={{fontSize: '15px', backgroundColor: 'rgba(255, 255, 255, 0.1)', cursor: 'pointer'}} onClick={() => setIsOpen2(false)} />
                </div>
                <p className="mb-3 mt-2 text-light fw-semibold" style={{fontSize: '15px'}}>Make a deposit into the user account</p>
                <label className="fw-semibold mb-2" style={{fontSize: '14px'}}>User:</label>
                <div className="d-flex align-items-between form-control justify-content-between py-1 pe-1">
                    <input 
                        type="text" 
                        placeholder={selectedUser.email}
                        className="inputNone w-100 py-1"
                        value={selectedUser.email}
                        readOnly
                    />
                </div>
                <label className="fw-semibold mb-1 mt-2" style={{fontSize: '14px'}}>Type of deposit:</label>
                <Select 
                    options={fundoptions} 
                    value={fundoptions.find((opt) => opt.value === dtype)}
                    onChange={(e) => {setDtype(e.value)}}
                    styles={darkThemeStyles}
                    className="w-full"
                />
                <label className="fw-semibold mt-2 mb-1" style={{fontSize: '14px'}}>Amount:</label>
                <div className={`d-flex align-items-between form-control justify-content-between py-1 pe-1`}>
                <input 
                    type="text" 
                    placeholder="0.001" 
                    className="inputNone"
                    value={damount}
                    onChange={(e) => {setDamount(e.target.value);}}
                />
                <Select 
                    options={assethistory}
                    placeholder="Assets" 
                    value={assethistory.find(opt => opt.value === dasset)}
                    onChange={opt => (setDasset(opt.value), setDsymbol(opt.symbol), setDbalance(opt.amount), setDprice(opt.price))}
                    isSearchable
                    styles={darkThemeStyles1}
                    className="w-full"
                />
                </div>
                <div className="d-flex align-items-center justify-content-between">
                <p style={{fontSize:'14px'}}>Current {dsymbol} balance:</p>
                <p style={{fontSize:'14px'}}>{dbalance} {dsymbol}</p>
                </div>
                <div className={`myBtn bg-prime w-100 text-center mt-3`} style={{paddingTop: '12px',paddingBottom: '12px'}} onClick={AddBalance}>{loading?<FontAwesomeIcon icon={faCircleNotch} style={{fontSize: '20px', color: 'white', opacity: '0.5'}} spin />:'Add deposit'}</div>
            </Modal>
            <Modal
                isOpen={modalIsOpen3}
                onRequestClose={() => setIsOpen3(false)}
                shouldCloseOnOverlayClick={true} 
                closeTimeoutMS={100}
                className="shortmode"
            >
                <div className="d-flex align-items-center justify-content-between">
                    <p className="mb-0 fw-bold text-white" style={{fontSize: '15px'}}>Add profits</p>
                    <FontAwesomeIcon className="py-1 px-2 rounded-3" icon={faXmark} style={{fontSize: '15px', backgroundColor: 'rgba(255, 255, 255, 0.1)', cursor: 'pointer'}} onClick={() => setIsOpen3(false)} />
                </div>
                <p className="mb-3 mt-2 text-light fw-semibold" style={{fontSize: '15px'}}>Add profits to the user account</p>
                <label className="fw-semibold mb-2" style={{fontSize: '14px'}}>User:</label>
                <div className="d-flex align-items-between form-control justify-content-between py-1 pe-1">
                    <input 
                        type="text" 
                        placeholder={selectedUser.email}
                        className="inputNone w-100 py-1"
                        value={selectedUser.email}
                        readOnly
                    />
                </div>
                <label className="fw-semibold mt-2 mb-1" style={{fontSize: '14px'}}>Profits:</label>
                <div className={`d-flex align-items-between form-control justify-content-between py-1 pe-1`}>
                <input 
                    type="text" 
                    placeholder="How much profits do you want to add?" 
                    className="inputNone"
                    value={pamount}
                    onChange={(e) => {setPamount(e.target.value);}}
                />
                <Select 
                    options={assethistory}
                    placeholder="Assets" 
                    value={assethistory.find(opt => opt.value === passet)}
                    onChange={opt => (setPasset(opt.value), setPprice(opt.price), setPsymbol(opt.symbol))}
                    isSearchable
                    styles={darkThemeStyles1}
                    className="w-full"
                />
                </div>
                <div className="d-flex align-items-center justify-content-between">
                    <p style={{fontSize:'14px'}}>Current profits:</p>
                    <p style={{fontSize:'14px'}}>${selectedUser.profit}</p>
                </div>
                <div className={`myBtn bg-prime w-100 text-center mt-3`} style={{paddingTop: '12px',paddingBottom: '12px'}} onClick={AddProfit}>{loading?<FontAwesomeIcon icon={faCircleNotch} style={{fontSize: '20px', color: 'white', opacity: '0.5'}} spin />:'Add profits'}</div>
            </Modal>
            <Modal
                isOpen={modalIsOpen4}
                onRequestClose={() => setIsOpen4(false)}
                shouldCloseOnOverlayClick={true} 
                closeTimeoutMS={100}
                className="shortmode"
            >
                <div className="d-flex align-items-center justify-content-between">
                    <p className="mb-0 fw-bold text-white" style={{fontSize: '15px'}}>Add loss</p>
                    <FontAwesomeIcon className="py-1 px-2 rounded-3" icon={faXmark} style={{fontSize: '15px', backgroundColor: 'rgba(255, 255, 255, 0.1)', cursor: 'pointer'}} onClick={() => setIsOpen4(false)} />
                </div>
                <p className="mb-3 mt-2 text-light fw-semibold" style={{fontSize: '15px'}}>Add a loss to the user account. Be careful using this, do not go over the user's current profits or balance</p>
                <label className="fw-semibold mb-2" style={{fontSize: '14px'}}>User:</label>
                <div className="d-flex align-items-between form-control justify-content-between py-1 pe-1">
                    <input 
                        type="text" 
                        placeholder={selectedUser.email}
                        className="inputNone w-100 py-1"
                        value={selectedUser.email}
                        readOnly
                    />
                </div>
                <label className="fw-semibold mt-2 mb-1" style={{fontSize: '14px'}}>Profits:</label>
                <div className={`d-flex align-items-between form-control justify-content-between py-1 pe-1`}>
                <input 
                    type="text" 
                    placeholder="How much profits do you want to add?" 
                    className="inputNone"
                    value={lamount}
                    onChange={(e) => {setLamount(e.target.value);}}
                />
                <Select 
                    options={assethistory}
                    placeholder="Assets" 
                    value={assethistory.find(opt => opt.value === lasset)}
                    onChange={opt => (setLasset(opt.value), setLprice(opt.price), setLsymbol(opt.symbol), setLbalance(opt.amount))}
                    isSearchable
                    styles={darkThemeStyles1}
                    className="w-full"
                />
                </div>
                <div className="d-flex align-items-center justify-content-between">
                    <p className="mb-0" style={{fontSize:'14px'}}>Current profits:</p>
                    <p className="mb-0" style={{fontSize:'14px'}}>${selectedUser.profit}</p>
                </div>
                <div className="d-flex align-items-center justify-content-between">
                <p className="mb-0" style={{fontSize:'14px'}}>Current {lsymbol} balance:</p>
                <p className="mb-0" style={{fontSize:'14px'}}>{lbalance} {lsymbol}</p>
                </div>
                <div className={`myBtn bg-prime w-100 text-center mt-3`} style={{paddingTop: '12px',paddingBottom: '12px'}} onClick={AddLoss}>{loading?<FontAwesomeIcon icon={faCircleNotch} style={{fontSize: '20px', color: 'white', opacity: '0.5'}} spin />:'Add loss'}</div>
            </Modal>
            <Modal
                isOpen={modalIsOpen5}
                onRequestClose={() => setIsOpen5(false)}
                shouldCloseOnOverlayClick={true} 
                closeTimeoutMS={100}
                className="shortmode"
            >
                <div className="d-flex align-items-center justify-content-between">
                    <p className="mb-0 fw-bold text-white" style={{fontSize: '15px'}}>Reset user balance</p>
                    <FontAwesomeIcon className="py-1 px-2 rounded-3" icon={faXmark} style={{fontSize: '15px', backgroundColor: 'rgba(255, 255, 255, 0.1)', cursor: 'pointer'}} onClick={() => setIsOpen5(false)} />
                </div>
                <p className="mb-3 mt-2 text-light fw-semibold" style={{fontSize: '15px'}}>This will set {rsymbol} balance to 0</p>
                <label className="fw-semibold mb-2" style={{fontSize: '14px'}}>User:</label>
                <div className="d-flex align-items-between form-control justify-content-between py-1 pe-1">
                    <input 
                        type="text" 
                        placeholder={selectedUser.email}
                        className="inputNone w-100 py-1"
                        value={selectedUser.email}
                        readOnly
                    />
                </div>
                <label className="fw-semibold mb-2 mt-2" style={{fontSize: '14px'}}>Balance to reset:</label>
                <div className="d-flex align-items-between form-control justify-content-between py-2">
                    <label className="fw-semibold mb-0" style={{fontSize: '14px'}}>Reset all balances</label>
                    <Switch
                        onChange={() => setChecked(!checked)}
                        checked={checked}
                        offColor="#404448"
                        onColor="#404448"
                        offHandleColor="#8c95a0"
                        onHandleColor="#ff6b35"
                        uncheckedIcon={false}
                        checkedIcon={false}
                        height={23}
                        width={40}
                        handleDiameter={18}
                    />
                </div>
                <label className="fw-semibold mt-2 mb-1" style={{fontSize: '14px'}}>Asset:</label>
                <Select 
                    options={assethistory}
                    placeholder="Assets" 
                    value={assethistory.find(opt => opt.value === rasset)}
                    onChange={opt => (setRasset(opt.value), setRsymbol(opt.symbol), setRbalance(opt.amount))}
                    isSearchable
                    styles={darkThemeStyles}
                    className="w-full"
                />
                <div className="d-flex align-items-center justify-content-between">
                <p className="mb-0" style={{fontSize:'14px'}}>Current {rsymbol} balance:</p>
                <p className="mb-0" style={{fontSize:'14px'}}>{rbalance} {rsymbol}</p>
                </div>
                <div className={`myBtn bg-prime w-100 text-center mt-3`} style={{paddingTop: '12px',paddingBottom: '12px'}} onClick={ResetAsset}>{loading?<FontAwesomeIcon icon={faCircleNotch} style={{fontSize: '20px', color: 'white', opacity: '0.5'}} spin />:'Add loss'}</div>
            </Modal>
            <Modal
                isOpen={modalIsOpen6}
                onRequestClose={() => setIsOpen6(false)}
                shouldCloseOnOverlayClick={true} 
                closeTimeoutMS={100}
                className="shortmode"
            >
                <div className="d-flex align-items-center justify-content-between">
                    <p className="mb-0 fw-bold text-white" style={{fontSize: '15px'}}>Set trading progress</p>
                    <FontAwesomeIcon className="py-1 px-2 rounded-3" icon={faXmark} style={{fontSize: '15px', backgroundColor: 'rgba(255, 255, 255, 0.1)', cursor: 'pointer'}} onClick={() => setIsOpen6(false)} />
                </div>
                <label className="fw-semibold mb-2 mt-4" style={{fontSize: '14px'}}>User:</label>
                <div className="d-flex align-items-between form-control justify-content-between py-1 pe-1">
                    <input 
                        type="text" 
                        placeholder={selectedUser.email}
                        className="inputNone w-100 py-1"
                        value={selectedUser.email}
                        readOnly
                    />
                </div>
                <label className="fw-semibold mt-3 mb-1" style={{fontSize: '14px'}}>Trading Progress:</label>
                <div className={`d-flex align-items-between form-control justify-content-between py-1 pe-1`}>
                    <input 
                        type="text" 
                        placeholder="0" 
                        className="inputNone"
                        value={progress}
                        onChange={(e) => {setProgress(e.target.value);}}
                    />
                    <div className="px-2 py-1 rounded-3" style={{backgroundColor:'#1f2325ff'}}>%</div>
                </div>
                <div className="d-flex align-items-center justify-content-between mt-1">
                    <p className="mb-0" style={{fontSize:'14px'}}>Current trading progress:</p>
                    <p className="mb-0" style={{fontSize:'14px'}}>{selectedUser.trade_progress}%</p>
                </div>
                <div className={`myBtn bg-prime w-100 text-center mt-5`} style={{paddingTop: '12px',paddingBottom: '12px'}} onClick={SetProgress}>{loading?<FontAwesomeIcon icon={faCircleNotch} style={{fontSize: '20px', color: 'white', opacity: '0.5'}} spin />:'Set'}</div>
            </Modal>
            <Modal
                isOpen={modalIsOpen7}
                onRequestClose={() => setIsOpen7(false)}
                shouldCloseOnOverlayClick={true} 
                closeTimeoutMS={100}
                className="shortmode"
            >
                <div className="d-flex align-items-center justify-content-between">
                    <p className="mb-0 fw-bold text-white" style={{fontSize: '15px'}}>Set signal strength</p>
                    <FontAwesomeIcon className="py-1 px-2 rounded-3" icon={faXmark} style={{fontSize: '15px', backgroundColor: 'rgba(255, 255, 255, 0.1)', cursor: 'pointer'}} onClick={() => setIsOpen7(false)} />
                </div>
                <label className="fw-semibold mb-2 mt-4" style={{fontSize: '14px'}}>User:</label>
                <div className="d-flex align-items-between form-control justify-content-between py-1 pe-1">
                    <input 
                        type="text" 
                        placeholder={selectedUser.email}
                        className="inputNone w-100 py-1"
                        value={selectedUser.email}
                        readOnly
                    />
                </div>
                <label className="fw-semibold mt-3 mb-1" style={{fontSize: '14px'}}>Signal Strength:</label>
                <div className={`d-flex align-items-between form-control justify-content-between py-1 pe-1`}>
                    <input 
                        type="text" 
                        placeholder="0" 
                        className="inputNone"
                        value={signalStrength}
                        onChange={(e) => {setSignalStrength(e.target.value);}}
                    />
                    <div className="px-2 py-1 rounded-3" style={{backgroundColor:'#1f2325ff'}}>%</div>
                </div>
                <div className="d-flex align-items-center justify-content-between mt-1">
                    <p className="mb-0" style={{fontSize:'14px'}}>Current signal strength:</p>
                    <p className="mb-0" style={{fontSize:'14px'}}>{selectedUser.signals}%</p>
                </div>
                <div className={`myBtn bg-prime w-100 text-center mt-5`} style={{paddingTop: '12px',paddingBottom: '12px'}} onClick={SetSignal}>{loading?<FontAwesomeIcon icon={faCircleNotch} style={{fontSize: '20px', color: 'white', opacity: '0.5'}} spin />:'Set'}</div>
            </Modal>
            <Modal
                isOpen={modalIsOpen8}
                onRequestClose={() => setIsOpen8(false)}
                shouldCloseOnOverlayClick={true} 
                closeTimeoutMS={100}
                className="shortmode"
            >
                <div className="d-flex align-items-center justify-content-between">
                    <p className="mb-0 fw-bold text-white" style={{fontSize: '15px'}}>Manage signal balance</p>
                    <FontAwesomeIcon className="py-1 px-2 rounded-3" icon={faXmark} style={{fontSize: '15px', backgroundColor: 'rgba(255, 255, 255, 0.1)', cursor: 'pointer'}} onClick={() => setIsOpen8(false)} />
                </div>
                <p className="mb-3 mt-2 text-light fw-semibold" style={{fontSize: '15px'}}>You can add or remove funds from this user's signal balance. Please do not remove more than the current balance.</p>
                <label className="fw-semibold mb-2" style={{fontSize: '14px'}}>User:</label>
                <div className="d-flex align-items-between form-control justify-content-between py-1 pe-1">
                    <input 
                        type="text" 
                        placeholder={selectedUser.email}
                        className="inputNone w-100 py-1"
                        value={selectedUser.email}
                        readOnly
                    />
                </div>
                <label className="fw-semibold mb-1 mt-3" style={{fontSize: '14px'}}>What do you want to do?</label>
                <Select
                options={typeoptions} 
                value={typeoptions.find((opt) => opt.value === stype)}
                onChange={(e) => {setStype(e.value)}}
                styles={darkThemeStyles}
                className="w-full"
                />
                <label className="fw-semibold mt-3 mb-1" style={{fontSize: '14px'}}>Amount:</label>
                <div className={`d-flex align-items-between form-control justify-content-between py-1 pe-1`}>
                    <input 
                        type="text" 
                        placeholder="How much do you want to add?" 
                        className="inputNone"
                        value={samount}
                        onChange={(e) => {setSamount(e.target.value);}}
                    />
                    <div className="px-2 py-1 rounded-3" style={{backgroundColor:'#1f2325ff'}}>USD</div>
                </div>
                <div className="d-flex align-items-center justify-content-between mt-1">
                    <p className="mb-0" style={{fontSize:'14px'}}>Current signal balance:</p>
                    <p className="mb-0" style={{fontSize:'14px'}}>{selectedUser.signal_balance} USD</p>
                </div>
                <div className={`myBtn bg-prime w-100 text-center mt-5`} style={{paddingTop: '12px',paddingBottom: '12px'}} onClick={AddSignalBal}>{loading?<FontAwesomeIcon icon={faCircleNotch} style={{fontSize: '20px', color: 'white', opacity: '0.5'}} spin />:'Add'}</div>
            </Modal>
            <Modal
                isOpen={modalIsOpen9}
                onRequestClose={() => setIsOpen9(false)}
                shouldCloseOnOverlayClick={true} 
                closeTimeoutMS={100}
                className="shortmode"
            >
                <div className="d-flex align-items-center justify-content-between">
                    <p className="mb-0 fw-bold text-white" style={{fontSize: '15px'}}>Manage subscription balance</p>
                    <FontAwesomeIcon className="py-1 px-2 rounded-3" icon={faXmark} style={{fontSize: '15px', backgroundColor: 'rgba(255, 255, 255, 0.1)', cursor: 'pointer'}} onClick={() => setIsOpen9(false)} />
                </div>
                <p className="mb-3 mt-2 text-light fw-semibold" style={{fontSize: '15px'}}>You can add or remove funds from this user's subscription balance. Please do not remove more than the current balance.</p>
                <label className="fw-semibold mb-2" style={{fontSize: '14px'}}>User:</label>
                <div className="d-flex align-items-between form-control justify-content-between py-1 pe-1">
                    <input 
                        type="text" 
                        placeholder={selectedUser.email}
                        className="inputNone w-100 py-1"
                        value={selectedUser.email}
                        readOnly
                    />
                </div>
                <label className="fw-semibold mb-1 mt-3" style={{fontSize: '14px'}}>What do you want to do?</label>
                <Select
                options={typeoptions1} 
                value={typeoptions1.find((opt) => opt.value === sbtype)}
                onChange={(e) => {setSbtype(e.value)}}
                styles={darkThemeStyles}
                className="w-full"
                />
                <label className="fw-semibold mt-3 mb-1" style={{fontSize: '14px'}}>Amount:</label>
                <div className={`d-flex align-items-between form-control justify-content-between py-1 pe-1`}>
                    <input 
                        type="text" 
                        placeholder="How much do you want to add?" 
                        className="inputNone"
                        value={sbamount}
                        onChange={(e) => {setSbamount(e.target.value);}}
                    />
                    <div className="px-2 py-1 rounded-3" style={{backgroundColor:'#1f2325ff'}}>USD</div>
                </div>
                <div className="d-flex align-items-center justify-content-between mt-1">
                    <p className="mb-0" style={{fontSize:'14px'}}>Current subscription balance:</p>
                    <p className="mb-0" style={{fontSize:'14px'}}>{selectedUser.subscription_balance} USD</p>
                </div>
                <div className={`myBtn bg-prime w-100 text-center mt-5`} style={{paddingTop: '12px',paddingBottom: '12px'}} onClick={AddSubBal}>{loading?<FontAwesomeIcon icon={faCircleNotch} style={{fontSize: '20px', color: 'white', opacity: '0.5'}} spin />:'Add'}</div>
            </Modal>
            <Modal
                isOpen={modalIsOpen10}
                onRequestClose={() => setIsOpen10(false)}
                shouldCloseOnOverlayClick={true} 
                closeTimeoutMS={100}
                className="shortmode"
            >
                <div className="d-flex align-items-center justify-content-between">
                    <p className="mb-0 fw-bold text-white" style={{fontSize: '15px'}}>Manage referral balance</p>
                    <FontAwesomeIcon className="py-1 px-2 rounded-3" icon={faXmark} style={{fontSize: '15px', backgroundColor: 'rgba(255, 255, 255, 0.1)', cursor: 'pointer'}} onClick={() => setIsOpen10(false)} />
                </div>
                <p className="mb-3 mt-2 text-light fw-semibold" style={{fontSize: '15px'}}>You can add or remove funds from this user's referral balance. Please do not remove more than the current balance.</p>
                <label className="fw-semibold mb-2" style={{fontSize: '14px'}}>User:</label>
                <div className="d-flex align-items-between form-control justify-content-between py-1 pe-1">
                    <input 
                        type="text" 
                        placeholder={selectedUser.email}
                        className="inputNone w-100 py-1"
                        value={selectedUser.email}
                        readOnly
                    />
                </div>
                <label className="fw-semibold mb-1 mt-3" style={{fontSize: '14px'}}>What do you want to do?</label>
                <Select
                options={typeoptions2} 
                value={typeoptions2.find((opt) => opt.value === rtype)}
                onChange={(e) => {setRtype(e.value)}}
                styles={darkThemeStyles}
                className="w-full"
                />
                <label className="fw-semibold mt-3 mb-1" style={{fontSize: '14px'}}>Amount:</label>
                <div className={`d-flex align-items-between form-control justify-content-between py-1 pe-1`}>
                    <input 
                        type="text" 
                        placeholder="How much do you want to add?" 
                        className="inputNone"
                        value={ramount}
                        onChange={(e) => {setRamount(e.target.value);}}
                    />
                    <div className="px-2 py-1 rounded-3" style={{backgroundColor:'#1f2325ff'}}>USD</div>
                </div>
                <div className="d-flex align-items-center justify-content-between mt-1">
                    <p className="mb-0" style={{fontSize:'14px'}}>Current referral balance:</p>
                    <p className="mb-0" style={{fontSize:'14px'}}>{selectedUser.bonus} USD</p>
                </div>
                <div className={`myBtn bg-prime w-100 text-center mt-5`} style={{paddingTop: '12px',paddingBottom: '12px'}} onClick={AddRefBal}>{loading?<FontAwesomeIcon icon={faCircleNotch} style={{fontSize: '20px', color: 'white', opacity: '0.5'}} spin />:'Add'}</div>
            </Modal>
            <Modal
                isOpen={modalIsOpen11}
                onRequestClose={() => setIsOpen11(false)}
                shouldCloseOnOverlayClick={true} 
                closeTimeoutMS={100}
                className="shortmode"
            >
                <div className="d-flex align-items-center justify-content-between">
                    <p className="mb-0 fw-bold text-white" style={{fontSize: '15px'}}>Manage profits</p>
                    <FontAwesomeIcon className="py-1 px-2 rounded-3" icon={faXmark} style={{fontSize: '15px', backgroundColor: 'rgba(255, 255, 255, 0.1)', cursor: 'pointer'}} onClick={() => setIsOpen11(false)} />
                </div>
                <p className="mb-3 mt-2 text-light fw-semibold" style={{fontSize: '15px'}}>You can add or remove funds from this user's profits. Please do not remove more than the current profits.</p>
                <label className="fw-semibold mb-2" style={{fontSize: '14px'}}>User:</label>
                <div className="d-flex align-items-between form-control justify-content-between py-1 pe-1">
                    <input 
                        type="text" 
                        placeholder={selectedUser.email}
                        className="inputNone w-100 py-1"
                        value={selectedUser.email}
                        readOnly
                    />
                </div>
                <label className="fw-semibold mb-1 mt-3" style={{fontSize: '14px'}}>What do you want to do?</label>
                <Select
                options={typeoptions3} 
                value={typeoptions3.find((opt) => opt.value === ptype)}
                onChange={(e) => {setPtype(e.value)}}
                styles={darkThemeStyles}
                className="w-full"
                />
                <label className="fw-semibold mt-3 mb-1" style={{fontSize: '14px'}}>Amount:</label>
                <div className={`d-flex align-items-between form-control justify-content-between py-1 pe-1`}>
                    <input 
                        type="text" 
                        placeholder="How much do you want to add?" 
                        className="inputNone"
                        value={pramount}
                        onChange={(e) => {setPramount(e.target.value);}}
                    />
                    <div className="px-2 py-1 rounded-3" style={{backgroundColor:'#1f2325ff'}}>USD</div>
                </div>
                <div className="d-flex align-items-center justify-content-between mt-1">
                    <p className="mb-0" style={{fontSize:'14px'}}>Current profit:</p>
                    <p className="mb-0" style={{fontSize:'14px'}}>{selectedUser.profit} USD</p>
                </div>
                <div className={`myBtn bg-prime w-100 text-center mt-5`} style={{paddingTop: '12px',paddingBottom: '12px'}} onClick={AddProfitBal}>{loading?<FontAwesomeIcon icon={faCircleNotch} style={{fontSize: '20px', color: 'white', opacity: '0.5'}} spin />:'Add'}</div>
            </Modal>
            <Modal
                isOpen={modalIsOpen12}
                onRequestClose={() => setIsOpen12(false)}
                shouldCloseOnOverlayClick={true} 
                closeTimeoutMS={100}
                className="shortmode"
            >
                <div className="d-flex align-items-center justify-content-between">
                    <p className="mb-0 fw-bold text-white" style={{fontSize: '15px'}}>Upgrade account</p>
                    <FontAwesomeIcon className="py-1 px-2 rounded-3" icon={faXmark} style={{fontSize: '15px', backgroundColor: 'rgba(255, 255, 255, 0.1)', cursor: 'pointer'}} onClick={() => setIsOpen12(false)} />
                </div>
                <p className="mb-3 mt-2 text-light fw-semibold" style={{fontSize: '15px'}}>Upgrade the user account to a new account type.</p>
                <label className="fw-semibold mb-2" style={{fontSize: '14px'}}>User:</label>
                <div className="d-flex align-items-between form-control justify-content-between py-1 pe-1">
                    <input 
                        type="text" 
                        placeholder={selectedUser.email}
                        className="inputNone w-100 py-1"
                        value={selectedUser.email}
                        readOnly
                    />
                </div>
                <label className="fw-semibold mb-1 mt-3" style={{fontSize: '14px'}}>Current Account:</label>
                <div className={`form-control py-1 pe-1`}>
                    <input 
                        type="text" 
                        placeholder="" 
                        className="inputNone"
                        value={selectedUser.subscription}
                        readOnly
                    />
                </div>
                <label className="fw-semibold mt-3 mb-1" style={{fontSize: '14px'}}>New Account:</label>
                <Select
                options={planlist} 
                value={planlist.find((opt) => opt.value === plan)}
                onChange={(e) => {setPlan(e.value); setPlanAmount(e.amount)}}
                styles={darkThemeStyles}
                className="w-full"
                />
                <div className={`myBtn bg-prime w-100 text-center mt-5`} style={{paddingTop: '12px',paddingBottom: '12px'}} onClick={UpgradeAccount}>{loading?<FontAwesomeIcon icon={faCircleNotch} style={{fontSize: '20px', color: 'white', opacity: '0.5'}} spin />:'Upgrade'}</div>
            </Modal>
            <Modal
                isOpen={modalIsOpen13}
                onRequestClose={() => setIsOpen13(false)}
                shouldCloseOnOverlayClick={true} 
                closeTimeoutMS={100}
                className="shortmode"
            >
                <div className="d-flex align-items-center justify-content-between">
                    <p className="mb-0 fw-bold text-white" style={{fontSize: '15px'}}>Generate deposit history</p>
                    <FontAwesomeIcon className="py-1 px-2 rounded-3" icon={faXmark} style={{fontSize: '15px', backgroundColor: 'rgba(255, 255, 255, 0.1)', cursor: 'pointer'}} onClick={() => setIsOpen13(false)} />
                </div>
                <label className="fw-semibold mb-1 mt-3" style={{fontSize: '14px'}}>From:</label>
                <DatePicker className="form-control py-2 px-3" selected={fromDate} onChange={(date) => setFromDate(date)} showTimeSelect dateFormat="Pp" />
                <label className="fw-semibold mb-1 mt-3" style={{fontSize: '14px'}}>To:</label>
                <DatePicker className="form-control py-2 px-3" selected={toDate} onChange={(date) => setToDate(date)} showTimeSelect dateFormat="Pp" />
                <label className="fw-semibold mt-3 mb-1" style={{fontSize: '14px'}}>Number of Deposits:</label>
                <Select
                    options={depositlist} 
                    value={depositlist.find((opt) => opt.value === noGenerate)}
                    onChange={(e) => {setNoGenerate(e.value)}}
                    styles={darkThemeStyles}
                    className="w-full"
                />
                <label className="fw-semibold mt-3 mb-1" style={{fontSize: '14px'}}>Asset:</label>
                <Select
                    options={assethistory} 
                    value={assethistory.find((opt) => opt.value === tasset)}
                    onChange={(e) => {setTasset(e.value)}}
                    styles={darkThemeStyles}
                    className="w-full"
                />
                <label className="fw-semibold mt-3 mb-1" style={{fontSize: '14px'}}>Status:</label>
                <Select
                    options={statuslist} 
                    value={statuslist.find((opt) => opt.value === tstatus)}
                    onChange={(e) => {setTstatus(e.value)}}
                    styles={darkThemeStyles}
                    className="w-full"
                />
                <div className={`myBtn bg-prime w-100 text-center mt-5`} style={{paddingTop: '12px',paddingBottom: '12px'}} onClick={GenerateDeposit}>{loading?<FontAwesomeIcon icon={faCircleNotch} style={{fontSize: '20px', color: 'white', opacity: '0.5'}} spin />:'Generate'}</div>
            </Modal>
            <Modal
                isOpen={modalIsOpen14}
                onRequestClose={() => setIsOpen14(false)}
                shouldCloseOnOverlayClick={true} 
                closeTimeoutMS={100}
                className="shortmode"
            >
                <div className="d-flex align-items-center justify-content-between">
                    <p className="mb-0 fw-bold text-white" style={{fontSize: '15px'}}>Generate withdrawal history</p>
                    <FontAwesomeIcon className="py-1 px-2 rounded-3" icon={faXmark} style={{fontSize: '15px', backgroundColor: 'rgba(255, 255, 255, 0.1)', cursor: 'pointer'}} onClick={() => setIsOpen14(false)} />
                </div>
                <label className="fw-semibold mb-1 mt-3" style={{fontSize: '14px'}}>From:</label>
                <DatePicker className="form-control py-2 px-3" selected={fromDate} onChange={(date) => setFromDate(date)} showTimeSelect dateFormat="Pp" />
                <label className="fw-semibold mb-1 mt-3" style={{fontSize: '14px'}}>To:</label>
                <DatePicker className="form-control py-2 px-3" selected={toDate} onChange={(date) => setToDate(date)} showTimeSelect dateFormat="Pp" />
                <label className="fw-semibold mt-3 mb-1" style={{fontSize: '14px'}}>Number of Deposits:</label>
                <Select
                    options={depositlist} 
                    value={depositlist.find((opt) => opt.value === noGenerate)}
                    onChange={(e) => {setNoGenerate(e.value)}}
                    styles={darkThemeStyles}
                    className="w-full"
                />
                <label className="fw-semibold mt-3 mb-1" style={{fontSize: '14px'}}>Type:</label>
                <Select
                    options={withdrawlist} 
                    value={withdrawlist.find((opt) => opt.value === wtype)}
                    onChange={(e) => {setWtype(e.value)}}
                    styles={darkThemeStyles}
                    className="w-full"
                />
                {wtype == "Crypto" && (
                    <>
                    <label className="fw-semibold mt-3 mb-1" style={{fontSize: '14px'}}>Asset:</label>
                    <Select
                        options={assethistory} 
                        value={assethistory.find((opt) => opt.value === tasset)}
                        onChange={(e) => {setTasset(e.value)}}
                        styles={darkThemeStyles}
                        className="w-full"
                    />
                    </>
                )}
                <label className="fw-semibold mt-3 mb-1" style={{fontSize: '14px'}}>Status:</label>
                <Select
                    options={statuslist} 
                    value={statuslist.find((opt) => opt.value === tstatus)}
                    onChange={(e) => {setTstatus(e.value)}}
                    styles={darkThemeStyles}
                    className="w-full"
                />
                <div className={`myBtn bg-prime w-100 text-center mt-5`} style={{paddingTop: '12px',paddingBottom: '12px'}} onClick={GenerateWithdraw}>{loading?<FontAwesomeIcon icon={faCircleNotch} style={{fontSize: '20px', color: 'white', opacity: '0.5'}} spin />:'Generate'}</div>
            </Modal>
            <Modal
                isOpen={modalIsOpen15}
                onRequestClose={() => setIsOpen15(false)}
                shouldCloseOnOverlayClick={true} 
                closeTimeoutMS={100}
                className="shortmode"
            >
                <div className="d-flex align-items-center justify-content-between">
                    <p className="mb-0 fw-bold text-white" style={{fontSize: '15px'}}>Fix a trade</p>
                    <FontAwesomeIcon className="py-1 px-2 rounded-3" icon={faXmark} style={{fontSize: '15px', backgroundColor: 'rgba(255, 255, 255, 0.1)', cursor: 'pointer'}} onClick={() => setIsOpen15(false)} />
                </div>
                <MiniTradeForm selectedUser={selectedUser}/>
            </Modal>
            <Modal
                isOpen={modalIsOpen16}
                onRequestClose={() => setIsOpen16(false)}
                shouldCloseOnOverlayClick={true} 
                closeTimeoutMS={100}
                className="widemode"
            >
                <div className="d-flex align-items-center justify-content-between">
                    <p className="mb-0 fw-bold text-white" style={{fontSize: '15px'}}>Edit User</p>
                    <FontAwesomeIcon className="py-1 px-2 rounded-3" icon={faXmark} style={{fontSize: '15px', backgroundColor: 'rgba(255, 255, 255, 0.1)', cursor: 'pointer'}} onClick={() => setIsOpen16(false)} />
                </div>
                <UserSettings selectedUser={selectedUser} setIsOpen16={setIsOpen16}/>
            </Modal>
            <Modal
                isOpen={modalIsOpen17}
                onRequestClose={() => setIsOpen17(false)}
                shouldCloseOnOverlayClick={true} 
                closeTimeoutMS={100}
                className="shortmode"
            >
                <div className="d-flex align-items-center justify-content-between">
                    <p className="mb-0 fw-bold text-white" style={{fontSize: '15px'}}>Add stock</p>
                    <FontAwesomeIcon className="py-1 px-2 rounded-3" icon={faXmark} style={{fontSize: '15px', backgroundColor: 'rgba(255, 255, 255, 0.1)', cursor: 'pointer'}} onClick={() => setIsOpen17(false)} />
                </div>
                <p className="mb-3 mt-2 text-light fw-semibold" style={{fontSize: '15px'}}>Purchase stock to user's account</p>
                <label className="fw-semibold mb-2" style={{fontSize: '14px'}}>User:</label>
                <div className="d-flex align-items-between form-control justify-content-between py-1 pe-1">
                    <input 
                        type="text" 
                        placeholder={selectedUser.email}
                        className="inputNone w-100 py-1"
                        value={selectedUser.email}
                        readOnly
                    />
                </div>
                <label className="fw-semibold mt-2 mb-1" style={{fontSize: '14px'}}>Asset:</label>
                <Select 
                    options={stock}
                    placeholder="Assets" 
                    value={stock.find(opt => opt.value === stasset)}
                    onChange={opt => (setStasset(opt.value), setStprice(opt.price), setStsymbol(opt.symbol))}
                    isSearchable
                    styles={darkThemeStyles}
                    className="w-full"
                />
                <label className="fw-semibold mt-2 mb-1" style={{fontSize: '14px'}}>Amount:</label>
                <div className={`d-flex align-items-between form-control justify-content-between py-1 pe-1`}>
                <input 
                    type="text" 
                    placeholder="How much profits do you want to add?" 
                    className="inputNone"
                    value={stamount}
                    onChange={(e) => {setStamount(e.target.value);}}
                />
                <div className="px-2 py-1 rounded-2" style={{backgroundColor: '#212527ff'}}>USD</div>
                </div>
                <div className={`myBtn bg-prime w-100 text-center mt-3`} style={{paddingTop: '12px',paddingBottom: '12px'}} onClick={Addstock}>{loading?<FontAwesomeIcon icon={faCircleNotch} style={{fontSize: '20px', color: 'white', opacity: '0.5'}} spin />:'Add stock'}</div>
            </Modal>
         </div>
    )
}
 
export default Actions